import { mask } from 'vue-the-mask'

export default {
  directives: {
    mask
  },
  data () {
    return {
			MAX_UPDATE_DELAY_IN_SECONDS: 120,
      validationRules: {
        required: v => !!v || 'Es necesario completar este campo',
      },
    }
  },
  computed: {
    uuid() {
      return this.$store.state.icoev.uuid;
    },
  },
  methods: {
    formatLocalDate (date) {
        if (!date) return null

        if (typeof date === 'number')
            date = new Date(date); //la entrada son milisegundos

        if (typeof date === 'string') {
            var parts = date.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
            date = new Date(parts[1], parts[2]-1, parts[3], parts[4], parts[5], parts[6]);
        }      

        return date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
    },
    formatLocalDateTime (date) {
        if (!date) return null

        if (typeof date === 'number')
            date = new Date(date); //la entrada son milisegundos

        if (typeof date === 'string') {
            var parts = date.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
            date = new Date(parts[1], parts[2]-1, parts[3], parts[4], parts[5], parts[6]);
        }

        return date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' })+ ' ' 
					+ date.toLocaleTimeString(['es-ES'], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    },
		needsUpdate(lastUpdate) {
			if (!lastUpdate) {
				return true;
			}

			//Obtenemos la diferencia en milisegundos
			var diff = new Date().getTime() - lastUpdate.getTime();

			//Convertimos la diferencia a segundos
			diff /= 1000;

			//Si la diferencia es mayor de MAX_UPDATE_DELAY_IN_SECONDS devolvemos true; si no, devolvemos false
			return diff > this.MAX_UPDATE_DELAY_IN_SECONDS;
		}
  }
}